import searchQueryPerformance from "./input/searchQueryPerformance.js"
import adPerformance from "./input/adPerformance.js"

export default {
  searchQueryPerformance,
  adPerformance
}



// WEBPACK FOOTER //
// ./src/config/input.js